import {configureStore, combineReducers} from '@reduxjs/toolkit';
import {baseApi} from '@/services/api/base-api';
import {baseAemApi} from '@/services/api/base-aem-api';
import cartSlice from '@/features/cart/slices/cart-slice';
import cartNotificationSlice from '@/features/cart/slices/cart-notification-slice';
import notificationsSlice from '@/features/notifications/slices/notifications-slice';
import productModalSlice from '@/features/product/product-modal/slices/product-modal-slice';

export const store = configureStore({
  reducer: combineReducers({
    [baseApi.reducerPath]: baseApi.reducer,
    [baseAemApi.reducerPath]: baseAemApi.reducer,
    cart: cartSlice,
    cartNotification: cartNotificationSlice,
    notifications: notificationsSlice,
    productModal: productModalSlice,
  }),
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(baseApi.middleware, baseAemApi.middleware),
});
